import { Action } from '@ngrx/store';
import { DRIVER_CREATE, DRIVER_DELETE, DRIVER_INVITATION_RESEND, DRIVERS_FETCH, USERS_CREATE, USERS_DELETE, USERS_INVITATION_RESEND } from '../action-types';
import { GROUP_DRIVERS, GROUP_USERS } from '../state-groups';
import { ListItemSetAction, ListItemUnsetAction, ListSetAction, ListSetFetchingAction } from '../shared/list/list.actions';
import { DRIVER_ENTITY } from '../entity-types';
import { SharedAction } from '../shared/actions/shared-action';
import { CreateUserRequest } from '@core/models/user/create-user-request';
import { ObservableAction } from '../shared/actions/observable-action';

export class FetchDriversAction implements Action {
    readonly type = DRIVERS_FETCH;

    constructor(
        public payload?: {
            locationId: string;
        }
    ) {}
}

@ObservableAction()
export class CreateDriverAction implements Action {
    readonly type = DRIVER_CREATE;

    constructor(
        public payload?: {
            request: CreateUserRequest;
        }
    ) {}
}

export class SetDriversAction extends ListSetAction implements Action {
    name = GROUP_DRIVERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = DRIVER_ENTITY;
    }
}

export class SetDriversFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_DRIVERS;

    constructor(payload: any) {
        super(payload);
    }
}

export class SetDriverAction extends ListItemSetAction implements SharedAction {
    name = GROUP_DRIVERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = DRIVER_ENTITY;
    }
}

export class UnsetDriverAction extends ListItemUnsetAction implements SharedAction {
    name = GROUP_DRIVERS;

    constructor(payload: any) {
        super(payload);
        payload.domain = DRIVER_ENTITY;
    }
}

@ObservableAction()
export class ResendDriverInvitationAction implements Action {
    readonly type = DRIVER_INVITATION_RESEND;

    constructor(
        public payload?: {
            driverId: string;
        }
    ) {}
}

@ObservableAction()
export class DeleteDriverAction implements Action {
    readonly type = DRIVER_DELETE;

    constructor(
        public payload?: {
            driverId: string;
        }
    ) {}
}
